module.exports = __webpack_public_path__ + "static/media/auth_logo_new.0c5fb565.png";